import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Summary_1_Right({ item, isSub }) {
  const isHtml = item.scale.isHtml;
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  return (
    <Row style={{ height: Number(item.height), marginBottom: "" }}>
      <Col xs={4}>
        <Row className={"justify-content-between"}>
          <Col className={"text-end " + (!isSub ? "_main-scope-name-pdf-new" : "_sub-scope-names-pdf-new")}>
            {item.name}
          </Col>
          <Col xs={"auto"}>
            <div className={isSub ? "_sub-scope-score-pdf-new _flex-center" : "_main-scope-score-pdf-new _flex-center"}>
              {elementScore}
            </div>
          </Col>
        </Row>
      </Col>
      <Col xs={8}>
        <Row>
          {item.scale.ranges.map((range, i) => {
            return (
              <Col
                key={i}
                className={
                  range.isHit
                    ? isSub
                      ? "_scale-style-pdf-new _hit-sub-scale-new _flex-center"
                      : "_scale-style-pdf-new _hit-scale-new _flex-center"
                    : "_scale-style-pdf-new _flex-center"
                }
              >
                {isHtml ? <div dangerouslySetInnerHTML={{ __html: range.text }} /> : range.text}
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
